import React, { useState } from 'react';
import { RouteTable } from './routes-table';
import { tripReducerSelector } from './../../../selector/trip-selectors';
import { useSelector } from 'react-redux';
import { RoutesForm } from './routes-form.component';
import { Col, Row, Layout } from 'antd';
import './routes.component.style.scss';


export const RoutesComponent = (props) => {

    const {
        formData
    } = props;

    let tripReducer = useSelector(tripReducerSelector);
    const [routesForm, setRoutesForm] = useState({});

    let {
        routes,
        routesLoading
    } = tripReducer;

    return (
        <Layout className="routes-layout">
            <Row justify="space-around" className="routes-row">
                <Col xs={24} sm={24} md={24} lg={8} xl={8} className="routes-form-col">
                    <RoutesForm
                        tripId={formData.id}
                        routesForm={routesForm}
                        setRoutesForm={setRoutesForm}
                        formData={formData}
                        routes={routes}
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={16} className="routes-table-col">
                    <RouteTable
                        tripId={formData.id}
                        dataSource={routes}
                        showFare={true}
                        isRemoveRouteEnable={false}
                        showDuration={true}
                        isRowClickable={true}
                        routesForm={routesForm}
                        setRoutesForm={setRoutesForm}
                        routesLoading={routesLoading}
                        showNextDay={false}
                    />
                </Col>
            </Row>
        </Layout>
    );
}
